import { render } from "./editUserRoleForm.vue?vue&type=template&id=f8238ef2&scoped=true"
import script from "./editUserRoleForm.vue?vue&type=script&lang=js"
export * from "./editUserRoleForm.vue?vue&type=script&lang=js"

import "./editUserRoleForm.vue?vue&type=style&index=0&id=f8238ef2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8238ef2"]])

export default __exports__